<template>
  <v-menu :nudge-width="100" size="12" v-if="multipleProviders || multipleBranchOffices">

    <v-btn  flat small slot="activator" active-class="active-menu">
      <v-avatar>
        <v-icon size="18" class="mr-1">{{selectedIcon}}</v-icon>
        <span>{{selectedAccountInitials}}</span>
      </v-avatar>
    </v-btn>

    <v-list two-line subheader>

      <template v-for="(provider, i) in availableProviders">

        <template v-if="provider.type === 'individual'" >
          <v-list-tile @click="setCurrentProvider({provider})" :key="`prov-${provider.id}`">
            <v-list-tile-title>
              <v-icon :color="currentProvider && currentProvider.id === provider.id ? 'primary': 'black'" size="18" class="pr-2">fa-user</v-icon>
              <span :class="currentProvider.id && currentProvider.id === provider.id ? 'primary--text': ''">{{provider.name}}</span>
            </v-list-tile-title>
          </v-list-tile>
        </template>

        <template v-else>
          <v-subheader style="font-size: 11px; height: 20px; margin-top: 10px;">{{provider.name}}</v-subheader>
          <v-list-tile @click="setBranchOffice(office, provider)"  v-for="(office, j) in provider.institution.branch_offices" :key="`off-${office.id}`">
            <v-list-tile-title>
              <v-icon :color="currentBranchOffice && currentBranchOffice.id === office.id ? 'primary': 'black'" size="18" class="pr-2">fa-warehouse</v-icon>
              <span :class="currentBranchOffice && currentBranchOffice.id === office.id ? 'primary--text': ''">{{office.name}}</span>
            </v-list-tile-title>
          </v-list-tile>
        </template>

        <v-divider v-if="i < availableProviders.length - 1"></v-divider>

      </template>


    </v-list>
  </v-menu>
</template>

<script>

import {mapGetters, mapMutations, mapState} from 'vuex'

export default {
  name: "AccountPickerBtn",
  data(){
    return {

    }
  },
  mounted(){
    const vm = this
  },
  computed:{
    ...mapState(['currentProvider', 'currentBranchOffice', 'branchOffices']),
    ...mapGetters(['availableProviders']),
    selectedAccountInitials(){
      const vm = this

      if(!vm.currentProvider  ||
          (vm.currentProvider && vm.currentProvider.type === 'institution' && (
              !vm.currentBranchOffice || !vm.currentBranchOffice.name
          ))) return '-'

      let nameToSplit = vm.currentProvider.type === 'individual' ?
            vm.currentProvider.name : vm.currentBranchOffice.name

      if(nameToSplit.length < 5) return nameToSplit

      const nameSplit = nameToSplit.split(' ')
      let str = nameSplit[0][0]

      if(nameSplit.length > 1){
        str += nameSplit[1][0]
      }

      return str.toUpperCase()

    },
    multipleProviders(){
      const vm = this
      return vm.availableProviders.length > 1
    },
    multipleBranchOffices(){
      const vm = this
      return vm.branchOffices.length > 1
    },
    selectedIcon(){
      const vm = this
      if(!vm.currentProvider) return ''

      if(vm.currentProvider.type === 'individual'){
        return 'fa-user'
      }

      return 'fa-warehouse'

    }
  },
  methods:{
    ...mapMutations(['setCurrentBranchOffice', 'setCurrentProvider']),
    setBranchOffice(office, provider){
      const vm = this
      vm.setCurrentProvider({provider, office})
    }
  }
}
</script>

<style scoped>
>>>.v-list--two-line .v-list__tile {
  height: 45px;
}
</style>